import React from 'react'
import { Box } from '@mui/material'

interface OktaSignInButtonProps {
  onClick: () => void
  disabled?: boolean
  loading?: boolean
}

const OKTA_BLUE = '#007DC1'

const OktaLogo: React.FC = () => (
  <svg width='21' height='21' viewBox='0 0 24 24' aria-hidden='true'>
    <path
      fill={OKTA_BLUE}
      d='M12 0C5.389 0 0 5.35 0 12s5.35 12 12 12 12-5.35 12-12S18.611 0 12 0zm0 18c-3.325 0-6-2.675-6-6s2.675-6 6-6 6 2.675 6 6-2.675 6-6 6z'
    />
  </svg>
)

/**
 * Okta Sign In Button, styled to match the Microsoft sign-in button.
 */
export const OktaSignInButton: React.FC<OktaSignInButtonProps> = ({
  onClick,
  disabled = false,
  loading = false,
}) => {
  const isDisabled = disabled || loading

  return (
    <Box
      component='button'
      onClick={onClick}
      disabled={isDisabled}
      aria-label='Sign in with Okta'
      sx={{
        width: '100%',
        height: '41px',
        padding: '0 12px',
        border: '1px solid #8C8C8C',
        borderRadius: '4px',
        backgroundColor: '#FFFFFF',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.6 : 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        transition: 'background-color 0.2s',
        '&:hover:not(:disabled)': {
          backgroundColor: '#F5F5F5',
        },
        '&:focus': {
          outline: `2px solid ${OKTA_BLUE}`,
          outlineOffset: '2px',
        },
      }}
    >
      <OktaLogo />
      <span
        style={{
          fontFamily: 'sans-serif',
          fontSize: '15px',
          fontWeight: 600,
          color: '#5E5E5E',
        }}
      >
        {loading ? 'Checking...' : 'Sign in with Okta'}
      </span>
    </Box>
  )
}
